import ActionTypes from "../../../../constants/ActionTypes";
import { AnyAction, Dispatch, Middleware, MiddlewareAPI } from "redux";
import { getOreSubmitDataFromBackup, setCampaignModeStatus, setCampaignOreSubmitDataAction } from "./actions";
import { getItemFromSessionStorage, setObjectAsSessionStorageItem } from "../../../../utilites/localStorage";

export const campaignModeStatusMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);
  switch (action.type) {
  case ActionTypes.CAMPAIGN.CAMPAIGN_MODE.SET_CAMPAIGN_ORE_SUBMIT_DATA:
    const productId = action.payload.product.id;
    setObjectAsSessionStorageItem(productId, action.payload);
    break;
  case ActionTypes.CAMPAIGN.CAMPAIGN_MODE.CHECK_FOR_ORE_SUBMIT_DATA:
    const id = action.payload;
    const campaignData = store.getState().campaign?.campaignMode?.oreSubmitData;
    if (!campaignData) {
      store.dispatch(getOreSubmitDataFromBackup(id));
    }
    break;
  case ActionTypes.CAMPAIGN.CAMPAIGN_MODE.GET_ORE_SUBMIT_DATA_FROM_BACKUP:
    const storedProductId = action.payload;
    const storedCampaignData = getItemFromSessionStorage(storedProductId, 'null');
    if (storedCampaignData) {
      try {
        const { product, oreOffer, channel } = storedCampaignData;
        next(setCampaignModeStatus(true));
        next(setCampaignOreSubmitDataAction(product, oreOffer, channel));
      } catch (e) {
        break;
      }
    }

    break;
  case ActionTypes.CAMPAIGN.CAMPAIGN_MODE.SET_CAMPAIGN_MODE_STATUS:
    break;
  }
};

export const campaignModeMiddleware = [
  campaignModeStatusMiddleware
];
